type Order = 'asc' | 'desc';

/**
 * A helper to help sort an array of objects containing ISO8601 timestamps.
 * 
 * @example
  ```ts
  import { sortIso8601 } from './utils/sort';

  const users = [{
    id: 'test-1',
    createdAt: '2023-08-09T13:11:06.698Z'
  }, {
    id: 'test-2',
    createdAt: '2023-07-09T13:11:06.698Z'
  }];

  const sortedUsers = users.sort(sortIso8601(user => user.createdAt, 'asc'));
  ```
 */
export function sortIso8601<T>(
  dateSelector: (object: T) => string,
  order: Order = 'desc',
) {
  return (a: T, b: T) => {
    const aDate = dateSelector(a);
    const bDate = dateSelector(b);

    if (order === 'asc') return aDate.localeCompare(bDate);

    return -aDate.localeCompare(bDate);
  };
}
